import { PageHeader } from '@/components/composites/PageHeader';
import { EmptyState } from '@/components/primitives/EmptyState';

interface PlaceholderPageProps {
  title: string;
  taskLabel: string;
}

export function PlaceholderPage({ title, taskLabel }: PlaceholderPageProps) {
  return (
    <>
      <PageHeader title={title} />
      <EmptyState
        title="Coming soon"
        description={`This page is under construction. ${taskLabel}`}
      />
    </>
  );
}
